export type {
  Cell,
  Direction,
  EntityId,
  GameInput,
  InputRejection,
  RuleContext,
  RuleEvent,
  RuleOutcome,
  RuleSet,
  RuleSetup,
  StepResult,
  Transition,
  TransitionBase,
  TransitionBatch,
} from './contracts';

export {
  clearRuleSetRegistry,
  getRuleSet,
  hasRuleSet,
  listRuleSets,
  registerRuleSet,
} from './registry';

export { NULL_RULE_SET_ID, nullRuleSet, type NullState } from './nullRuleSet';
export {
  BATTLE_RULE_SET_ID,
  battleRuleSet,
  type BattlePlayerState,
  type BattleState,
  type BattleStatus,
} from './battleRuleSet';

import { battleRuleSet } from './battleRuleSet';
import { nullRuleSet } from './nullRuleSet';
import { hasRuleSet, registerRuleSet } from './registry';

/**
 * Every ruleset the build knows about. Real rulesets get added to this function
 * and nowhere else. Called from `bootstrapShared()`, never as an import side
 * effect - see bootstrap.ts for why.
 */
export function registerBuiltInRuleSets(): void {
  if (!hasRuleSet(nullRuleSet.id)) registerRuleSet(nullRuleSet);
  if (!hasRuleSet(battleRuleSet.id)) registerRuleSet(battleRuleSet);
}
